import React, { useState } from 'react';
import { Button, Modal, Box, Typography, TextField } from '@mui/material';
import { isValidEmail } from '../utils/utils';
import API from '../API/API';


const EmailEntryOverlay = ({ project, link, setLink }) => {

  const {
    allBackgroundColor, allForegroundColor,
    toolBackgroundColor, toolForegroundColor
  } = project;

  const [receipt, setReceipt] = useState('');
  const [validEmail, setValidEmail] = useState(true);


  const handleInputChange = (e) => {
    setReceipt(e.target.value);
  };

  const handleSubmit = async () => {
    try {
      if (!isValidEmail(receipt)) {
        setValidEmail(false);
        return;
      } else {
        setValidEmail(true)
      }

      // Handle submission of email address here (e.g., send to server)
      const { linkEmail, message } = link;
      setLink(null); // Close modal after submission
      await API.sendEmail(linkEmail, receipt, message);
    } catch (error) {
      console.log("ERROR ", error);
    }
  };

  return (
    <div>
      <Modal
        open={!!link}
        onClose={() => setLink(null)}
        aria-labelledby="email-entry-modal-title"
        aria-describedby="email-entry-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '60%',
            bgcolor: toolBackgroundColor,
            border: '2px solid #000',
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography id="email-entry-modal-title" variant="h6" component="h2">
            Please Enter Your Email
          </Typography>
          <TextField
            id="email"
            label="Email Address"
            variant="outlined"
            fullWidth
            value={receipt}
            onChange={handleInputChange}
            sx={{ mt: 2 }}
          />
          <Typography id="email-entry-modal-description" sx={{ mt: 1, color: 'red', fontSize: 12, display: validEmail ? 'none' : 'flex' }}>
            Please enter a valid email
          </Typography>
          <Typography id="email-entry-modal-description" sx={{ mt: 2, color: toolForegroundColor || 'black' }}>
            { link?.message }
          </Typography>
          <Button variant="contained" onClick={handleSubmit} sx={{ mt: 2, bgcolor: allBackgroundColor || 'rgb(43, 30, 94)', color: allForegroundColor || 'white' }}>
            Submit
          </Button>
          <Button onClick={() => setLink(null)} sx={{ mt: 2, ml: 2, bgcolor: 'red', color: allForegroundColor || 'white' }}>
            Close
          </Button>
        </Box>
      </Modal>
    </div>
  );
};

export default EmailEntryOverlay;
